export default "__VITE_ASSET__CZ477OU4__"